// The FULL Phase 3 transcription prompt, authored HERE on the client and sent verbatim —
// the same contract every other phase's prompt has, so the badge shows the string the server
// receives.
//
// IT ASKS FOR ONE THING AND KNOWS NOTHING ELSE. No parts list, no earlier steps, no
// catalogue, no JSON shape to reason about: the input is a page and a step number, and the
// answer is on the page. That is the whole argument for the call existing — a transcription
// is not a judgement, and it was riding on the call that makes the hardest judgement in the
// app (see stepAnalyzePrompt, which no longer asks for it).
//
// WHOLE PAGES, AND SO EACH STEP'S PAGES ARE NAMED. A band is cut where the next step's segment
// starts — a boundary drawn for diagrams, which has been seen to clip a step's own last line
// mid-sentence. A page cannot clip, but a page may carry two steps, so the prompt says which
// steps are on which pages and the model keeps each step's text to that step.
export function buildStepInstructionsPrompt(steps: { num: number; pages: number[] }[]): string {
  const where = steps
    .map((s) => `- Step ${s.num}: page${s.pages.length > 1 ? 's' : ''} ${s.pages.join(', ')}`)
    .join('\n');
  return (
    'These are the pages of a furniture manual on which its assembly steps are printed, each ' +
    'captioned with its page number. A page may show more than one step. The steps, and the ' +
    `pages each is printed on:\n${where}\n\n` +
    'For EACH step, transcribe the instruction text printed for it, once per language it is ' +
    'printed in. VERBATIM: the manual\'s own words, spelling, numbering and punctuation, ' +
    'and nothing added, translated, summarised or tidied.\n\n' +
    'Take only what belongs to that step — not a neighbouring step\'s text, not the page ' +
    'header or footer, not a part label or a callout letter, and not a measurement printed ' +
    'on the diagram. A step that prints no text takes [].\n\n' +
    'Reply with ONLY a JSON object, no prose, no code fence, one entry per step:\n' +
    '{"steps": [{"step": <step number>, "instructions": [{"lang": <ISO 639-1 code>, "text": <string>}]}]}'
  );
}
